<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Control de movimientos en patio</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="2">
            <p class="text-right black--text">Día a revisar</p>
          </v-col>
          <v-col cols="3">
            <date-picker 
              placeholder="Fecha" 
              class="dtpicker" 
              v-model="start_date" 
              format="DD-MM-YYYY" 
              valueType="YYYY-MM-DD"
              @change="loadMovements">
            </date-picker>
          </v-col>
          <v-col cols="3">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="movSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar movimientos"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="movimientosListHeaders"
          :items="movimientosListBody"
          class="elevation-3"
          dense
          no-data-text="No hay movimientos"
          :search="movSearch"
          :hide-default-footer="true"
          disable-pagination
          fixed-header
          :height="table_height"
        >
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center" colspan="8">Totales</th>
              <th class="title text-center">
                  {{ sumaColumna('bins800') }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('bins1000') }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('otros_bins') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
        movSearch: null,
        start_date: new Date().toISOString().substr(0, 10),
        isLoading: false,
        url_excel: '',
        table_height: 600,
        movimientosListHeaders: [
        {
          text: 'Movimiento',
          align: 'center',
          sortable: true,
          value: 'movimiento',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'turno',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Hora',
          align: 'center',
          sortable: true,
          value: 'hora',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia',
          align: 'center',
          sortable: true,
          value: 'guia',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patente',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Proveedor',
          align: 'center',
          sortable: true,
          value: 'proveedor',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Certificado',
          align: 'center',
          sortable: true,
          value: 'certificado',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Bins 800',
          align: 'center',
          sortable: true,
          value: 'bins800',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Bins 1000',
          align: 'center',
          sortable: true,
          value: 'bins1000',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Otros Bins',
          align: 'center',
          sortable: true,
          value: 'otros_bins',
          class: "salmon black--text elevation-3"
        },
      ],
      movimientosListBody: [],
    }),
    mounted() {
      this.loadMovements();
    },
    methods:{
      sumaColumna(key) {
        let total = 0;
        this.movimientosListBody.forEach(row => {
            total += parseInt(row[key]);
        });
        return total;
      },
      async loadMovements(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}reports/movimientos/patio/${this.start_date}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.movimientosListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>